var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.f724f2e9c77f53bf8ceb61199ee2fddf.svg#check-outline';
                    var viewUrl = 'svg/global.f724f2e9c77f53bf8ceb61199ee2fddf.svg#view-check-outline';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };